import { render, staticRenderFns } from "./DisplayStatus.vue?vue&type=template&id=1a5e24d8&scoped=true&"
import script from "./DisplayStatus.vue?vue&type=script&lang=js&"
export * from "./DisplayStatus.vue?vue&type=script&lang=js&"
import style0 from "./DisplayStatus.vue?vue&type=style&index=0&id=1a5e24d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5e24d8",
  null
  
)

export default component.exports